import { Component, ChangeDetectorRef } from '@angular/core';
import {
  NavController,
  NavParams,
  ActionSheetController,
  AlertController
} from 'ionic-angular';
import { TaskQL, Task } from '../../providers/tasks/models';
import { TasksProvider } from '../../providers/tasks/tasks';
import { DevicesProvider } from '../../providers/devices/devices';
import { UtilsProvider } from '../../providers/utils/utils';

/**
 * Generated class for the TasksCompletePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-tasks-complete',
  templateUrl: 'tasks-complete.html'
})
export class TasksCompletePage {
  public tasks: TaskQL[];
  public isloading: boolean = false;
  public selectedStatus: Array<string> = [Task.StatusEnum.Closed];
  public selectedType: string = '';
  public updateTask: any;
  private startDate: Date;
  public startDateStr: string;
  private endDate: Date;
  public endDateStr: string;
  public lastRequestInfo: {
    totalCount: number;
    nextLookAfterKey: number | string;
    previousLookBeforeKey: number | string;
    items: any[];
    isdone: boolean;
  } = null;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public actionSheetCtrl: ActionSheetController,
    public alertCtrl: AlertController,
    private cd: ChangeDetectorRef,
    private tasksProvider: TasksProvider,
    private devicesProvider: DevicesProvider,
    private utilsProvider: UtilsProvider,
  ) {
    this.isloading = false;
    this.updateTask = this.navParams.get('updateTask');
    this.navParams.data.updateTask = null;
  }
  ionViewDidLoad() {}
  ionViewDidEnter() {
    this.endDate = new Date();
    this.endDate.setHours(23);
    this.endDate.setMinutes(59);
    this.endDate.setSeconds(59);
    this.endDateStr = this.endDate.toISOString();

    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 30);
    this.startDate.setHours(0);
    this.startDate.setMinutes(0);
    this.startDate.setSeconds(0);
    this.startDateStr = this.startDate.toISOString();

    this.lastRequestInfo = null;
    this.initTasks(true);
  }

  initTasks(refresh: boolean = false, event?) {
    // updateTask
    if (!this.isloading) {
      this.isloading = true;
      if (refresh) {
        this.lastRequestInfo = null;
      }
      const params = {
        limit: 10,
        filters: {
          status: { _in: ['closed'] },
          completedDate: {
            _gt: this.startDate.getTime(),
            _lt: this.endDate.getTime()
          }
        },
        sortFilter: {
          field: 'assignedDate',
          direction: 'ASC'
        },
        lookAfter: null
      };

      if (this.lastRequestInfo) {
        params.lookAfter = this.lastRequestInfo.nextLookAfterKey;
      }

      console.log('REQUEST: ', params);

      this.tasksProvider.getTasks(params).subscribe(
        data => {
          console.log('DATA: ', data);
          this.tasks =
            this.tasks && this.tasks.length > 0
              ? this.tasks.concat(data.items)
              : data.items;

          if (!this.lastRequestInfo) {
            this.lastRequestInfo = data;
          } else {
            this.lastRequestInfo.nextLookAfterKey = data.nextLookAfterKey;
            this.lastRequestInfo.previousLookBeforeKey =
              data.previousLookBeforeKey;
            this.lastRequestInfo.items = data.items;
          }

          if (this.tasks.length === this.lastRequestInfo.totalCount) {
            this.lastRequestInfo.isdone = true;
          }

          this.cd.detectChanges();
          if (event) event.complete();
          this.isloading = false;
        },
        e => {
          this.cd.detectChanges();
          if (event) event.complete();
          this.isloading = false;
        }
      );
    }
  }

  dateChange(datestr: any, type: string) {
    if (!this.isloading) {
      if (type === 'start') {
        this.startDate = new Date(datestr);
      } else {
        this.endDate = new Date(datestr);
      }
      this.tasks = [];
      this.initTasks(true);
    } else {
      this.startDateStr = this.startDate.toISOString();
      this.endDateStr = this.endDate.toISOString();
    }
  }

  dateToString(date: Date) {
    var year = date.getFullYear().toString();
    var month = (date.getMonth() + 1).toString();
    var day = date.getDate().toString();

    return year + '-' + month + '-' + day;
  }

  doInfinite(event) {
    if (!this.isloading && !this.lastRequestInfo.isdone) {
      this.initTasks(false, event);
    } else {
      event.complete();
    }
  }

  pagingIsComplete() {
    if (this.lastRequestInfo)
      return this.lastRequestInfo && this.lastRequestInfo.isdone ? true : false;
  }

  doRefresh(event) {
    if (!this.isloading) {
      this.tasks = [];
      this.initTasks(true, event);
    } else {
      event.complete();
    }
  }

  getDeviceType(task: TaskQL) {
    return this.devicesProvider.getDeviceTypeLabel(task.deviceType);
  }

  getProviderName(id) {
    return this.utilsProvider.groupSnnToName(id);
  }

  openTask(task) {
    // Do this to avoid future readonly task error
    // const cacheTask = JSON.parse(JSON.stringify(task));
    // this.tasksProvider.setSelectedTask(cacheTask);
    // this.navCtrl.push(TasksCompleteDetailPage, { task: cacheTask });
  }
}



// WEBPACK FOOTER //
// ./src/pages/tasks-complete/tasks-complete.ts